var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-expansion-panel",
    {
      staticClass: "elevation-0",
      attrs: { expand: "", focusable: true },
      model: {
        value: _vm.panels,
        callback: function($$v) {
          _vm.panels = $$v
        },
        expression: "panels"
      }
    },
    [
      _c(
        "v-expansion-panel-content",
        {
          staticClass: "background darken-1 launcher-panel",
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "header-content" },
                    [
                      _c("v-icon", { staticClass: "mr-2" }, [
                        _vm._v("account_circle")
                      ]),
                      _vm._v("\n\t\t\t\tVos dernières demandes\n\t\t\t\t"),
                      _vm.user_last_jrs_loading
                        ? _c("v-progress-linear", {
                            staticClass: "ml-2 my-0",
                            attrs: {
                              indeterminate: "",
                              height: 2,
                              color: "primary"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          _c(
            "v-card",
            { staticClass: "background darken-1" },
            [
              _c(
                "v-card-text",
                { staticClass: "pt-0" },
                [
                  _c("table", [
                    _c("colgroup", [
                      _c("col", { staticStyle: { width: "0px" } }),
                      _vm._v(" "),
                      _c("col", { staticStyle: { width: "0px" } }),
                      _vm._v(" "),
                      _c("col", { staticStyle: { width: "auto" } }),
                      _vm._v(" "),
                      _c("col", { staticStyle: { width: "0px" } }),
                      _vm._v(" "),
                      _c("col", { staticStyle: { width: "0px" } })
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.user_last_jrs, function(jr) {
                        return _c("tr", { key: jr.id }, [
                          _c(
                            "td",
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "", color: "background" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "router-link",
                                              _vm._g(
                                                {
                                                  attrs: {
                                                    to: {
                                                      name: "Maestro job",
                                                      params: { jr_id: jr.id }
                                                    },
                                                    target: "_blank"
                                                  }
                                                },
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    {
                                                      staticClass: "ma-0",
                                                      attrs: {
                                                        flat: "",
                                                        icon: ""
                                                      }
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("open_in_new")
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v("#" + _vm._s(jr.id) + " Détails")
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", { staticClass: "nowrap" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t" +
                                _vm._s(jr.descriptor.label) +
                                "\n\t\t\t\t\t\t\t"
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("div", { staticClass: "line-break-anywhere" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t" +
                                  _vm._s(jr.infos.label || "-") +
                                  "\n\t\t\t\t\t\t\t\t"
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "caption line-break-anywhere" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "background--text text--lighten-5"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(jr.infos.title || "-") +
                                        "\n\t\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { class: _vm.$colors.setColorText(jr) }, [
                            _c("div", [_vm._v(_vm._s(jr.status_text))]),
                            _vm._v(" "),
                            _c("div", { staticClass: "caption text-right" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t" +
                                  _vm._s(Math.floor(jr.progress)) +
                                  "%\n\t\t\t\t\t\t\t\t"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "", color: "background" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  staticClass: "ma-0",
                                                  attrs: { flat: "", icon: "" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.duplicateJR(
                                                        jr.id
                                                      )
                                                    }
                                                  }
                                                },
                                                on
                                              ),
                                              [
                                                _c("v-icon", [
                                                  _vm._v("content_copy")
                                                ])
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Dupliquer la demande")])
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      }),
                      0
                    )
                  ]),
                  _vm._v(" "),
                  _vm.user_last_jrs.length
                    ? _c(
                        "v-toolbar",
                        {
                          staticClass: "paginator",
                          attrs: { flat: "", color: "transparent", height: 42 }
                        },
                        [
                          _c("v-spacer"),
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.user_last_jrs_pagin) +
                              "\n\t\t\t\t\t"
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                flat: "",
                                icon: "",
                                disabled: _vm.user_last_jrs_page === 1
                              },
                              on: {
                                click: function($event) {
                                  _vm.user_last_jrs_page--
                                  _vm.fetchUserLastJrs()
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("chevron_left")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-0",
                              attrs: {
                                flat: "",
                                icon: "",
                                disabled:
                                  _vm.user_last_jrs_page ===
                                  _vm.user_last_jrs_nb_page
                              },
                              on: {
                                click: function($event) {
                                  _vm.user_last_jrs_page++
                                  _vm.fetchUserLastJrs()
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("chevron_right")])],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.jd_selected
        ? _c(
            "v-expansion-panel-content",
            {
              staticClass: "background darken-1 launcher-panel",
              scopedSlots: _vm._u(
                [
                  {
                    key: "header",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          { staticClass: "header-content" },
                          [
                            _c("v-icon", { staticClass: "mr-2" }, [
                              _vm._v("account_tree")
                            ]),
                            _vm._v(
                              "\n\t\t\t\tLes derniers " +
                                _vm._s(_vm.jd_selected.label) +
                                "\n\t\t\t\t"
                            ),
                            _vm.jd_last_jrs_loading
                              ? _c("v-progress-linear", {
                                  staticClass: "ml-2 my-0",
                                  attrs: {
                                    indeterminate: "",
                                    height: 2,
                                    color: "primary"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                2732802226
              )
            },
            [
              _vm._v(" "),
              _c(
                "v-card",
                { staticClass: "background darken-1" },
                [
                  _c(
                    "v-card-text",
                    { staticClass: "pt-0" },
                    [
                      _c("table", [
                        _c("colgroup", [
                          _c("col", { staticStyle: { width: "0px" } }),
                          _vm._v(" "),
                          _c("col", { staticStyle: { width: "0px" } }),
                          _vm._v(" "),
                          _c("col", { staticStyle: { width: "auto" } }),
                          _vm._v(" "),
                          _c("col", { staticStyle: { width: "0px" } }),
                          _vm._v(" "),
                          _c("col", { staticStyle: { width: "0px" } })
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.jd_last_jrs, function(jr) {
                            return _c("tr", { key: jr.id }, [
                              _c(
                                "td",
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: {
                                        bottom: "",
                                        color: "background"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              return [
                                                _c(
                                                  "router-link",
                                                  _vm._g(
                                                    {
                                                      attrs: {
                                                        to: {
                                                          name: "Maestro job",
                                                          params: {
                                                            jr_id: jr.id
                                                          }
                                                        },
                                                        target: "_blank"
                                                      }
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        {
                                                          staticClass: "ma-0",
                                                          attrs: {
                                                            flat: "",
                                                            icon: "",
                                                            small: ""
                                                          }
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: { small: "" }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "open_in_new"
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v("#" + _vm._s(jr.id) + " Détails")
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _c("div", { staticClass: "nowrap" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(jr.descriptor.label) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "caption nowrap" },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          small: "",
                                          color: "background lighten-3"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\tperson\n\t\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    ),
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(jr.requestor.name) +
                                        "\n\t\t\t\t\t\t\t\t"
                                    )
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "div",
                                  { staticClass: "line-break-anywhere" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(jr.infos.label || "-") +
                                        "\n\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "caption line-break-anywhere"
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "background--text text--lighten-5"
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(jr.infos.title || "-") +
                                            "\n\t\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { class: _vm.$colors.setColorText(jr) },
                                [
                                  _c("div", [_vm._v(_vm._s(jr.status_text))]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "text-right caption" },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(Math.floor(jr.progress)) +
                                          "%\n\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: {
                                        bottom: "",
                                        color: "background"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    {
                                                      staticClass: "ma-0",
                                                      attrs: {
                                                        flat: "",
                                                        icon: ""
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.duplicateJR(
                                                            jr.id
                                                          )
                                                        }
                                                      }
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("content_copy")
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v("Dupliquer la demande")
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          }),
                          0
                        )
                      ]),
                      _vm._v(" "),
                      _vm.jd_last_jrs.length
                        ? _c(
                            "v-toolbar",
                            {
                              staticClass: "paginator",
                              attrs: {
                                flat: "",
                                color: "transparent",
                                height: 42
                              }
                            },
                            [
                              _c("v-spacer"),
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(_vm.jd_last_jrs_pagin) +
                                  "\n\t\t\t\t\t"
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    flat: "",
                                    icon: "",
                                    disabled: _vm.jd_last_jrs_page === 1
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.jd_last_jrs_page--
                                      _vm.fetchJdLastJrs()
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("chevron_left")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mr-0",
                                  attrs: {
                                    flat: "",
                                    icon: "",
                                    disabled:
                                      _vm.jd_last_jrs_page ===
                                      _vm.jd_last_jrs_nb_page
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.jd_last_jrs_page++
                                      _vm.fetchJdLastJrs()
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("chevron_right")])],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a33ef660", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a33ef660","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/maestro/launcher/launcher_history.vue
// module id = null
// module chunks = 